export default {
    title: {
        default: 'Redeem History'
    },
    view_code: 'View Code',
    view_slip: 'View Slip',
}
